import { useQuery } from '@tanstack/react-query';

import { DatafeedApi } from '../api';
import { DatafeedCause } from './cause.types';

function useDatafeedSearchCauses({
  search,
  keepPreviousData = false,
}: {
  search?: string;
  keepPreviousData?: boolean;
}) {
  const getCauses = async () => {
    const { data } = await DatafeedApi.get<DatafeedCause[]>(
      `/causes/search/keywords?keywords=${search}`
    );
    return data;
  };

  return useQuery({
    queryKey: ['datafeed', 'causes', 'search', search],
    queryFn: getCauses,
    enabled: !!search,
    placeholderData: keepPreviousData ? (previousData) => previousData : undefined,
  });
}

function useDatafeedSearchCauseStores({ search }: { search?: string }) {
  const getCauseStores = async () => {
    const { data } = await DatafeedApi.get<DatafeedCause[]>(
      `/causes/search/stores/keywords?keywords=${search}`
    );
    return data;
  };

  return useQuery({
    queryKey: ['datafeed', 'causes', 'search', 'stores', search],
    queryFn: getCauseStores,
    enabled: !!search,
  });
}

export { useDatafeedSearchCauses, useDatafeedSearchCauseStores };
